import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { CompositePropagator, W3CTraceContextPropagator, W3CBaggagePropagator } from '@opentelemetry/core';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';

const resourceSettings = new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: 'hepp.react',
});

const traceExporter = new OTLPTraceExporter({
    url: process.env.REACT_APP_INSTRUMENTED_ENDPOINT || 'http://localhost:4318/v1/traces',
    headers:{}
});

const provider = new WebTracerProvider({ resource: resourceSettings });

provider.addSpanProcessor(new BatchSpanProcessor(traceExporter));

provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new CompositePropagator({
        propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
    }),
});

const startOtelInstrumentation = () => {
    console.info(`Registering Otel ${new Date().getMilliseconds()}`);

    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            getWebAutoInstrumentations({
                '@opentelemetry/instrumentation-xml-http-request': {
                    enabled: true,
                    clearTimingResources: true,
                    propagateTraceHeaderCorsUrls: [new RegExp(process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT || 'http://localhost:8000')],
                    applyCustomAttributesOnSpan: (span, request) => {
                        span.updateName(`${request.responseURL} ${request.statusText}`);
                    },
                },
                '@opentelemetry/instrumentation-fetch': {
                    propagateTraceHeaderCorsUrls: [new RegExp(process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT || 'http://localhost:8000')],
                    enabled: true,
                    applyCustomAttributesOnSpan: (span, request) => {
                        if (request instanceof Request) {
                            span.updateName(`${request.method} ${request.url}`);
                        }
                    },
                },
                '@opentelemetry/instrumentation-document-load': {
                    enabled: true,
                },
                '@opentelemetry/instrumentation-user-interaction': {
                    eventNames: ['submit', 'click', 'keypress'],
                },
            }),
        ],
    });
};

export { startOtelInstrumentation };
